import CompaniesService from '../services/Companies.service';
import { observable } from 'mobx';

class CompaniesStore {
  companies = observable([]);

  initialFetchDone = observable.box(false);

  setCompanies(companies) {
    this.companies.push(...companies);
    this.initialFetchDone.set(true);
  }

  async getCompanyBySlug(slug) {
    let activeCompany = this.companies.find(company => company.slug === slug);

    if (!activeCompany) {
      return;
    }

    if (activeCompany.isFull) {
      return activeCompany;
    }

    try {
      const items = await CompaniesService.getCompanyBySlug(slug);

      if (items.isEmpty) {
        return null;
      }

      if (items.items.length > 1) {
        throw new DOMException(
          'getCompanyBySlug method should have returned only one item'
        );
      }

      const fetchedCompany = items.items[0];
      fetchedCompany.isFull = true;

      Object.assign(activeCompany, fetchedCompany);

      return fetchedCompany;
    } catch (e) {
      console.error('Failed to fetch case study data', e);
      return null;
    }
  }
}

export default new CompaniesStore();



// WEBPACK FOOTER //
// ./src/stores/Companies.js